/** The ArtlessDev app is a separate deployment from this marketing site, so
 *  every link that leaves the site for the product (`/sign-in`, `/sign-up`,
 *  `/workspaces`) has to carry the app's origin rather than resolving
 *  against this one.
 *
 *  `VITE_APP_ORIGIN` overrides the default for preview/staging deploys; set
 *  it to an empty string to make every app link same-origin again, which is
 *  what a local `npm run dev` with both surfaces behind one proxy wants. */
const DEFAULT_APP_ORIGIN = "https://app.artless.dev"

export function appOrigin(): string {
  const configured = import.meta.env.VITE_APP_ORIGIN
  if (configured === undefined) return DEFAULT_APP_ORIGIN
  return configured.trim().replace(/\/+$/, "")
}

/** Absolute URL for a path inside the app, e.g. `appUrl("/sign-in")`. */
export function appUrl(path: string): string {
  return `${appOrigin()}${path}`
}
